import { useEffect, useRef } from "react";

/**
 * Overlay while a flight tape plays: REPLAY badge, loop + stop controls, and
 * the recorded stick positions rendered as two gimbal boxes (Mode 2: left =
 * throttle/yaw, right = pitch/roll) — the FPV-DVR touch. Stick dots update at
 * frame rate via direct style writes from the shared sticks ref.
 */
export function ReplayHud({
  sticks, loop, setLoop, onStop,
}: {
  sticks: React.MutableRefObject<[number, number, number, number]>;
  loop: boolean;
  setLoop: (v: boolean) => void;
  onStop: () => void;
}) {
  const dotL = useRef<HTMLDivElement>(null);
  const dotR = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let raf = 0;
    const tick = () => {
      const [thr, yaw, pitch, roll] = sticks.current;
      if (dotL.current) {
        dotL.current.style.left = 50 + yaw * 44 + "%";
        dotL.current.style.top = 94 - thr * 88 + "%";
      }
      if (dotR.current) {
        dotR.current.style.left = 50 + roll * 44 + "%";
        dotR.current.style.top = 50 - pitch * 44 + "%";
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [sticks]);

  return (
    <div className="replay-hud">
      <div className="replay-top">
        <span className="replay-badge">▶ REPLAY</span>
        <button className={"chip mini" + (loop ? " active" : "")} onClick={() => setLoop(!loop)} title="Loop the tape">⟳ Loop</button>
        <button className="chip mini" onClick={onStop}>■ Stop</button>
      </div>
      <div className="replay-sticks">
        <div className="stick-box"><div ref={dotL} className="stick-dot" /></div>
        <div className="stick-box"><div ref={dotR} className="stick-dot" /></div>
      </div>
    </div>
  );
}
